/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim1DiagRightIcon16Regular = forwardRef('ArrowDim1DiagRightIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8.75 2a.75.75 0 0 1 .75-.75h4c.69 0 1.25.56 1.25 1.25v4a.75.75 0 0 1-1.5 0V3.81l-9.44 9.44H6.5a.75.75 0 0 1 0 1.5h-4c-.69 0-1.25-.56-1.25-1.25v-4a.75.75 0 0 1 1.5 0v2.69l9.44-9.44H9.5A.75.75 0 0 1 8.75 2Z" })));
});
